import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminEngineSchema, adminRecordedSchema, adminRunStateSchema, } from "./common.js";
const percentilesSchema = z.object({ p50Ms: adminCountSchema, p95Ms: adminCountSchema });
/** Whether the answers arrived: yield per engine, outcomes, waiting and stuck runs. */
export const adminCaptureSchema = z.object({
    yield: z.array(z.object({
        day: adminDaySchema,
        engine: adminEngineSchema,
        expected: adminCountSchema,
        success: adminCountSchema,
    })),
    today: z.object({
        expected: adminCountSchema,
        byState: z.array(z.object({ state: adminRunStateSchema, count: adminCountSchema })),
    }),
    waiting: z.object({
        count: adminCountSchema,
        oldestMinutes: adminCountSchema.nullable(),
    }),
    latency: adminRecordedSchema(z.object({
        queueWait: percentilesSchema,
        vendor: percentilesSchema,
        afterwards: percentilesSchema,
    })),
    failureReasons: adminRecordedSchema(z.array(z.object({ reason: z.string(), count: adminCountSchema }))),
    stuck: z.object({
        total: adminCountSchema,
        rows: z.array(z.object({
            runId: z.string(),
            workspaceName: z.string(),
            engine: adminEngineSchema,
            runDate: adminDaySchema,
            ageHours: adminCountSchema,
            cause: z.enum(["no_task_id", "no_outcome_no_job", "unconfirmed"]),
        })),
    }),
});
//# sourceMappingURL=capture.js.map